export default function createMetadata() {
    const metadata = {
        browser_type: window.navigator.userAgent,
        browser_version: window.navigator.userAgent,
        sw_enabled: !!(
            window.navigator.serviceWorker &&
            window.navigator.serviceWorker.controller === 'controlled'
        ),
        path: window.location.pathname,
    };
    return metadata;
}
